import {v4 as uuidv4} from "uuid"
import {BlockType, MarkdownAtom, MarkdownBlock, MarkdownText} from "../model/markdown/MarkdownText"
import {atomParseService} from "./markdown/atomParseService"
import {blockParseService} from "./markdown/blockParseService"
import {plainTextService} from "./markdown/plainTextService"

class MarkdownService {
    parseMarkdown(sourceText: string): MarkdownText {
        const blocks = this.parseMarkdownBlocks(sourceText)
        return {
            blocks,
        }
    }

    getAsPlainText(markdownText: MarkdownText): string {
        if (markdownText === null || !markdownText) {
            return ''
        }
        let result = ''
        markdownText.blocks.forEach(block => {
            if (result.length > 0) {
                result += '\n'
            }
            switch (block.type) {
                case BlockType.PARAGRAPH:
                    result += plainTextService.getAtomsAsPlainText(block.atoms)
                    break
                case BlockType.CODE:
                    result += plainTextService.getCodeBlockAsPlainText(block.atoms)
                    break
                case BlockType.ORDERED_LIST:
                    result += plainTextService.getOrderedListAsText(block.atoms, block.startFrom)
                    break
                case BlockType.UNORDERED_LIST:
                    result += plainTextService.getUnorderedListAsText(block.atoms)
                    break
                case BlockType.HEADER_1:
                case BlockType.HEADER_2:
                case BlockType.HEADER_3:
                case BlockType.HEADER_4:
                case BlockType.HEADER_5:
                case BlockType.HEADER_6:
                    result += plainTextService.getAtomsAsPlainText(block.atoms)
                    break
                case BlockType.TABLE:
                    result += plainTextService.getTableAsPlainText(block.atoms)
                    break
            }
        })
        return result
    }

    getAfterToggleCheckbox(sourceText: string, atom: MarkdownAtom): string {
        const newChecked = !atom.checked
        return sourceText.substring(0, atom.posNo) + (newChecked ? 'x' : ' ') + sourceText.substring(atom.posNo + 1)
    }

    private parseMarkdownBlocks(sourceText: string): Array<MarkdownBlock> {
        const blocks: Array<MarkdownBlock> = []
        const lines = sourceText.split('\n')
        let posNo = 0
        for (let lineNo = 0; lineNo < lines.length; lineNo++) {
            const line = lines[lineNo]
            const parsedBlock = blockParseService.getParsedBlock(line, lines, lineNo)
            blocks.push({
                type: parsedBlock.type,
                lineNo,
                id: uuidv4(),
                atoms: atomParseService.getAtoms(parsedBlock, posNo),
                posNo,
                startFrom: parsedBlock.startFrom,
                hint: parsedBlock.hint,
                indent: parsedBlock.indent,
            })
            posNo += line.length + 1
            if (parsedBlock.lineSkipped > 0) {
                for (let i = 0; i < parsedBlock.lineSkipped; i++) {
                    if (lineNo + i + 1 < lines.length) {
                        posNo += (lines[lineNo + i + 1]).length + 1
                    }
                }
            }
            lineNo += parsedBlock.lineSkipped
        }
        return blocks
    }
}

export const markdownService = new MarkdownService()
